var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fpricediff",class:_vm.classes},[(_vm.diff !== 0)?[_c('span',{staticClass:"fpricediff_sign"},[_vm._v(_vm._s(_vm.sign))]),_vm._v(_vm._s(_vm.diffFormated)+"% ")]:[_vm._v(" - ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }